import { encrypt } from "../../../utils/encryption_decryption";

export function preparePayload(
    payload: Record<string, unknown>,
    isScanFile: boolean,
    isEncryptionEnabled: boolean
): unknown {
    const isExcelUpload = payload?.isExcelUpload === 1;
    if (isExcelUpload || isScanFile) {
        return payload;
    }

    if (isEncryptionEnabled) {
        return encrypt(payload);
    }

    return { data: payload };
}
